import store from '../store'
import { http } from '../plugins/http'

const needAuth = (auth) => auth === true

const findDefaultMenuItem = (mainMenu) => {
  if(mainMenu) {
    const result = mainMenu.find(n => n.isDefault);
    if(result)
      return result;

    const resultParent = mainMenu.find(n => n.subMenuItems && n.subMenuItems.find(x => x.isDefault));
    if(resultParent)
      return resultParent.subMenuItems.find(x => x.isDefault);
  }

  return null;
}

const ensureWizardStatus = () => {
  if (store.state.Wizard && store.state.Wizard.status !== null) {
    return Promise.resolve(store.state.Wizard.status)
  }
  return http
    .get('v1/wizard/status')
    .then(({ data }) => {
      store.dispatch('wizardSetData', { status: data })
      return data
    })
    .catch(() => {
      // Non-admin (403) or other error — wizard does not apply to this user
      const fallback = { wizardCompleted: true, notApplicable: true }
      store.dispatch('wizardSetData', { status: fallback })
      return fallback
    })
}

const proceedAfterAuth = (to, next) => {
  // Subscription / billing visibility rule: routes flagged requiresSignupAdmin are only
  // reachable by the original tenant admin who registered via /api/auth/signup.
  if (to.meta.requiresSignupAdmin && !store.getters.isSignupAdmin) {
    next('/')
    return
  }

  if(to.path === '/') {
    if(store.state.Auth.user.isShopFloorWorker) {
      next('/shopfloorcontrol')
    } else {
      var defaultMenuItem = findDefaultMenuItem(store.state.Auth.user.mainMenu);
      if (defaultMenuItem) {
        next({ name: defaultMenuItem.id })
      } else {
        next()
      }
    }
  } else {
    next()
  }
}

const beforeEach = (to, from, next) => {
  const auth = to.meta.requiresAuth

  if (!needAuth(auth)) {
    next()
    return
  }

  store
    .dispatch('checkUserToken')
    .then(() => {
      // Skip wizard check for:
      //  - the wizard route itself (avoid loop)
      //  - shop floor workers (different routing path)
      //  - any /auth route (e.g. signout) — must remain reachable from inside the wizard
      const targetIsAuth = typeof to.name === 'string' && to.name.startsWith('auth.')
      if (to.name === 'wizard.index'
        || targetIsAuth
        || store.state.Auth.user.isShopFloorWorker) {
        proceedAfterAuth(to, next)
        return
      }

      ensureWizardStatus().then((status) => {
        if (status && status.wizardCompleted === false) {
          next({ name: 'wizard.index' })
        } else {
          proceedAfterAuth(to, next)
        }
      })
    })
    .catch(() => {
      next({ name: 'auth.signin' })
    })
}

export default beforeEach
